/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './dental-surface.reducer';

export const DentalSurfaceDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const dentalSurfaceEntity = useAppSelector(state => state.dentalSurface.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="dentalSurfaceDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.dentalSurface.detail.title">DentalSurface</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.dentalSurface.id">Id</Translate>
            </span>
          </dt>
          <dd>{dentalSurfaceEntity.id}</dd>
          <dt>
            <span id="name">
              <Translate contentKey="tinyMedicRestApp.dentalSurface.name">Name</Translate>
            </span>
          </dt>
          <dd>{dentalSurfaceEntity.name}</dd>
          <dt>
            <span id="localization">
              <Translate contentKey="tinyMedicRestApp.dentalSurface.localization">Localization</Translate>
            </span>
          </dt>
          <dd>{dentalSurfaceEntity.localization}</dd>
          <dt>
            <span id="locale">
              <Translate contentKey="tinyMedicRestApp.dentalSurface.locale">Locale</Translate>
            </span>
          </dt>
          <dd>{dentalSurfaceEntity.locale}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.dentalSurface.active">Active</Translate>
            </span>
          </dt>
          <dd>{dentalSurfaceEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.dentalSurface.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{dentalSurfaceEntity.cursor}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.dentalSurface.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{dentalSurfaceEntity.lastupdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.dentalSurface.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{dentalSurfaceEntity.microSec}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.dentalSurface.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{dentalSurfaceEntity.timestampentry}</dd>
        </dl>
        <Button tag={Link} to="/dental-surface" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/dental-surface/${dentalSurfaceEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default DentalSurfaceDetail;
